import axios from 'axios'
import * as apiroutes from '../../apiroutes'
import localStorageService from './localStorageService'

class OrganizationServices {
    //Add New Organization
    addNewOrganization = async (data) => {
        // console.log("data: ", data)
        const a = new Promise((resolve, reject) => {
            axios
                .post(apiroutes.ORGANIZATION, data)
                .then((res) => {
                    return resolve(res)
                })
                .catch((error) => {
                    console.log('error', error.response)
                    return resolve(error.response)
                })
        })
        return await a
    }

    //Get All created orgs to admin view to orgmanagement table.
    getOrganizations = async (params) => {
        const accessToken = await localStorageService.getItem("accessToken");
        console.log("AT",accessToken)
        const a = new Promise((resolve, reject) => {
            axios
                .get(apiroutes.ORG_MANAGEMENT, {
                    params: params,
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    }
                })
                .then(res => {
                return resolve(res);
                })
                .catch((error) => {
                    console.log("error", error);
                    return resolve(error);
                })
        });
        return await a;
    }
    
    //get all org status views
    getAllOrganizations = async (params) => {
        const accessToken = await localStorageService.getItem("accessToken");
        // console.log("AT",accessToken)
        const a = new Promise((resolve, reject) => {
            axios
                .get(apiroutes.ORGANIZATION, {
                    params: params,
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    }
                })
                .then(res => {
                return resolve(res);
                })
                .catch((error) => {
                    console.log("error", error);
                    return resolve(error);
                })
        });
        // console.log("A",a)
        return await a;
    }

    //get organization status count
    getOrganizationStatusCount = async (params) => {
        const accessToken = await localStorageService.getItem("accessToken");
        // debugger
        console.log("accessToken", accessToken);
        const a = new Promise((resolve, reject) => {
            axios.get(apiroutes.ORG_STATUS_COUNT, {
                params: params,
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            }).then((res) => {
                return resolve(res);
            })
                .catch((error) => {
                    console.log("error in Expense", error);
                    return resolve(error);
                })
        });
        return await a;
    }

    // //Get Org details By ID
    getOrganizationByID = async (id) => {
        const accessToken = await localStorageService.getItem('accessToken')
        console.log("accessToken", accessToken);
        const promise = new Promise((resolve, reject) => {
            axios
                .get(apiroutes.ORG_REVIEW + `/${id}`, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    },
                    
                })
                .then((res) => {
                    return resolve(res)
                })
                .catch((error) => {
                    console.log('error', error)
                    return resolve(error)
                })
        })
        return await promise
    }

    //Organization Approval
    giveOrganizationApproval = async (data) => {
        const accessToken = await localStorageService.getItem("accessToken");
        // console.log("data: ", data)
        
        const a = new Promise((resolve, reject) => {

            axios
                .post(apiroutes.ORG_APPROVAL, data, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    }
                })
                .then((res) => {
                    return resolve(res)
                })
                .catch((error) => {
                    console.log('error', error)
                    return resolve(error)
                })
        })
        return await a
    }
}

export default new OrganizationServices()